<template>
  <div class="main">
    <f-canvas v-if="connected" :data="data" :height="canvas.height" :width="canvas.width" ref="canvas"></f-canvas>
  </div>
</template>

<script>

import Canvas from './Canvas.vue';

const { v4: uuid } = require('uuid');

export default {
  name: 'Main',
  components: {
    'f-canvas': Canvas
  },
  data () {
    return {
      ready: false,
      canvas: {
        width: 100,
        height: 100
      },
      connected: false,
      data: {}
    }
  },
  methods: {
    connect() {
      let { roomName } = this.$route.params;
      const { password } = this.$route.query;
      roomName = roomName.toLowerCase();

      const password_ = password || localStorage.getItem(`${roomName}_password`);

      const userName = localStorage.getItem('userName');
      const userId = localStorage.getItem('userId');

      if (!userName) localStorage.setItem('userName', 'Anonymous');
      if (!userId) localStorage.setItem('userId', uuid());

      localStorage.setItem('lastName', roomName);
      localStorage.setItem(`${roomName}_password`, password_);

      if (password) return window.location.href = `/${roomName}`

      this.connection.connect(password_, roomName)
        .then((result) => {
          this.data = result.data_;
          this.connected = result.status;

          document.title = `${roomName}`;
        })
        .catch((error) => {
          alert(error);

          this.$router.push('/')
        })
    }
  },
  mounted() {
    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;
  },
  created() {
    this.connect();
  },
  beforeDestroy() {
    this.connection.disconnect();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main.vue